import {createContext, use, type ReactNode} from 'react';
import {createPortal} from 'react-dom';

// A page's white filter bar can host controls owned by one of its tabs, without lifting their
// state into the page: the page provides the bar's slot element and the tab's component portals
// its controls into it. Outside a page that provides one - a component test, say - the controls
// render inline where the component put them.
const FilterBarSlotContext = createContext<HTMLElement | null>(null);

export const FilterBarSlotProvider = FilterBarSlotContext.Provider;

export function InFilterBar({children}: {readonly children: ReactNode}): ReactNode {
  const slot = use(FilterBarSlotContext);
  return slot ? createPortal(children, slot) : children;
}
